export default class SidebarHide {
    constructor(context) {
        this.context = context;

        this.initSidebarHide();
    }

    initSidebarHide() {
        if (this.context.children.length === 0) {
            this.context.remove();
        }
    }
}
